export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14720.71a0f5f1.jpg";